import { Badge } from '@flote/ui';
import type { DeliveryTaskStatus } from '@flote/types/delivery';

interface TaskStatusBadgeConfig {
  label: string;
  className: string;
}

const TASK_STATUS_CONFIG: Record<DeliveryTaskStatus, TaskStatusBadgeConfig> = {
  pending: {
    label: 'Pending',
    className: 'bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100',
  },
  assigned: {
    label: 'Assigned',
    className: 'bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-100',
  },
  in_transit: {
    label: 'In Transit',
    className: 'bg-indigo-100 text-indigo-800 border-indigo-200 hover:bg-indigo-100',
  },
  arrived: {
    label: 'Arrived',
    className: 'bg-violet-100 text-violet-800 border-violet-200 hover:bg-violet-100',
  },
  completed: {
    label: 'Completed',
    className: 'bg-green-100 text-green-800 border-green-200 hover:bg-green-100',
  },
  failed: {
    label: 'Failed',
    className: 'bg-red-100 text-red-800 border-red-200 hover:bg-red-100',
  },
};

interface TaskStatusBadgeProps {
  status: DeliveryTaskStatus;
  className?: string;
}

export function TaskStatusBadge({ status, className }: TaskStatusBadgeProps) {
  const config = TASK_STATUS_CONFIG[status] ?? {
    label: status,
    className: 'bg-gray-100 text-gray-800 border-gray-200',
  };

  return (
    <Badge className={`${config.className} ${className ?? ''}`}>
      {config.label}
    </Badge>
  );
}
